import {Pipe, PipeTransform} from '@angular/core';
import {arrow} from "ngx-bootstrap/positioning/modifiers";
import * as _ from 'underscore';

@Pipe({
  name: 'favoriteFilter'
})
export class FavoriteFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    console.log('FavoriteFilterPipe', args);
    if (args) {
      return _.chain(value).filter(courseGroup => {
        return _.filter(courseGroup['courses'], row =>{
          return row['progress'] && row['progress']['userCourse'] && row['progress']['userCourse']['favorite'];
        }).length > 0;
      }).value();

    }
    return value;

  }
}
